import CelesteLeftPseudoBox from './CelesteLeftPseudoBox';
import CelesteRightPseudoBox from './CelesteRightPseudoBox';

export const LeftPseudo = CelesteLeftPseudoBox;
export const RightPseudo = CelesteRightPseudoBox;
